function r(r){var n=typeof r;return null!=r&&("object"===n||"function"===n)}var n=function n(t,e){if(!r(t))return t;if(r(t))for(var f=0,o=Object.entries(t);f<o.length;f++){var u=o[f],i=u[0],c=u[1],a=e(c,i,t);a===c?r(c)&&(t[i]=n(c,e)):t[i]=a}return t};export{n as transform};
//# sourceMappingURL=index.module.js.map
